import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./index.css"; // External CSS

const AuthPage = () => {
    const navigate = useNavigate();
    const [counter, setCounter] = useState(5);

    const handleLogin = () => {
        const hotelURL = process.env.REACT_APP_LOGIN_URL;
        if (hotelURL) {
            window.location.href = hotelURL; // Same window redirect
        }
    };

    useEffect(() => {
        const tokenName = process.env.REACT_APP_API_TOKEN;
        if (tokenName) {
            const hasAuthCookie = document.cookie.includes(tokenName);
            if (hasAuthCookie) {
                navigate("/", { replace: true });
            }
        }
    }, [navigate]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter((prev) => prev - 1);
        }, 1000);

        const timeout = setTimeout(() => {
            handleLogin();
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className="auth-required-page">
            <div className="message-container">
                <h1>Authentication Required</h1>
                <p>You must log in to access this page.</p>
                <p className="redirect-message">
                    Redirecting to TRP login in {counter} second{counter !== 1 && "s"}...
                </p>
            </div>
        </div>
    );
};

export default AuthPage;
